import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import sharedStyles from "Components/elements/RVFlow/Shared/FlowNodeBlocks/FlowNodeBlocks.module.scss";
import {
    getJourneyNodeContentSummary,
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeType } from "Types/Journey";

// TODO: update type to import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";
// and follow up updateContactBlock or the IVR blocks work
const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.Reminder).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.Reminder);

export function ReminderBlock({ data }: { data: any }): JSX.Element {
    return (
        <BlockContainer variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle nodeData={data} fallBackDisplay={"Action"}></BlockTitle>

            <BlockContent isActive={true}>
                <div className="flex-column">
                    <div className={sharedStyles.breakText}>
                        {getJourneyNodeContentSummary(NodeType.Reminder, data)}
                    </div>
                </div>
            </BlockContent>
        </BlockContainer>
    );
}
